/**
 * /admin/v1/sessions API 客户端
 *
 * 承接：T11 §3.1 admin/v1/sessions · §4.2 M01 调试端会话视图数据源
 * 类型来源：S2 接 packages/api-types（openapi-typescript 生成）；本 PR 暂手写最小集
 */
import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/lib/api-client";

export interface SessionRecentItem {
	session_id: string;
	merchant_id: string;
	customer_id: string | null;
	start_time: string;
	last_activity_time: string;
	session_status: string;
	intent: string | null;
	progression_state: string;
	trace_id: string | null;
}

export interface SessionRecentResponse {
	items: SessionRecentItem[];
	total: number;
}

export function useRecentSessions(limit = 20) {
	return useQuery<SessionRecentResponse>({
		queryKey: ["admin", "sessions", "recent", limit],
		queryFn: async () => {
			const { data } = await apiClient.get<SessionRecentResponse>("/admin/v1/sessions/recent", {
				params: { limit },
			});
			return data;
		},
	});
}
